@if (additionalInfo?.singleSelection) {
  <lib-generic-dropdown
    [source]="buildingClassItems"
        [config]="{
            multiple: false,
            defaultText: 'Select Class',
            itemDisplayKey: 'name'
        }"
    [(selectedItem)]="selectedBuildingClass"
    (selectedItemChange)="onSelectBuildingClass()"
    >
  </lib-generic-dropdown>
} @else {
  <lib-generic-dropdown-multiselect
    [source]="buildingClassItems"
    [(selectedItems)]="selectedBuildingClasses"
    (selectedItemsChange)="onSelectedProductTypeChange()"
        [config]="{
            multiple: true,
            defaultText: 'Add Class',
            itemDisplayKey: 'name'
        }"
    [isReadOnly]="isReadOnly"
    >
  </lib-generic-dropdown-multiselect>
}

